import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useCustomSelector } from 'js/store/hooks';
import { POPUPS_REDUCER } from 'js/store/constants';
import { tagTypeService } from 'js/services/tagType.service';
import { useEffect, useRef, useState, useCallback } from 'react';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';
import { useGetWrapperLaunchUrl } from 'js/hooks/gameLauncher/hooks';
import { disablePopupsAction } from 'js/components/common/PopupManager';

import * as helpers from './helpers';

export const UCIP = () => {
    const dispatch = useDispatch();
    const [isInitialized, setIsInitialized] = useState(false);
    const featuresRef = useRef([]);
    const getWrapperLaunchUrl = useGetWrapperLaunchUrl();
    const popups = useCustomSelector(POPUPS_REDUCER, prop('popups'));
    const popupsCount = Object.keys(popups || {}).length;

    const setFeatures = useCallback((features) => {
        featuresRef.current = features;
    }, []);

    useEffect(() => {
        helpers.init();

        const handleMessage = (event) =>
            helpers.onMessage(event, {
                dispatch,
                setFeatures,
                setIsInitialized,
                getWrapperLaunchUrl
            });

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [getWrapperLaunchUrl, dispatch, setFeatures]);

    useEffect(() => {
        if (!isInitialized || !featuresRef.current.includes('displaystatus')) {
            return;
        }

        const hasPopups = popupsCount > 0;

        helpers.sendMessage({
            _type: 'ucip.displaystatus.w2gVisibilityChangeNotification',
            visible: !hasPopups
        });
    }, [popupsCount, isInitialized]);

    useEffect(() => {
        if (!isInitialized || !featuresRef.current.includes('autoplay')) {
            return;
        }

        const hasPopups = popupsCount > 0;

        if (hasPopups) {
            helpers.sendMessage({
                _type: 'ucip.autoplay.w2gInterruptGameplayCommand'
            });
        }
    }, [popupsCount, isInitialized]);

    useEffect(() => {
        if (!isInitialized || !featuresRef.current.includes('pause')) {
            return;
        }

        const hasPopups = popupsCount > 0;

        helpers.sendMessage({
            _type: 'ucip.pause.w2gPauseCommand',
            pause: hasPopups
        });
    }, [popupsCount, isInitialized, dispatch]);

    useEffect(() => {
        if (!isInitialized || !featuresRef.current.includes('pause')) {
            return;
        }

        dispatch(disablePopupsAction());
    }, [isInitialized, dispatch]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.ucip]: UCIP });
